<button
  [id]="button?.id"
  [attr.aria-label]="ariaLabel"
  [name]="button?.name"
  (click)="onClick($event.target)"
  [class]="button?.class"
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
